import { render, staticRenderFns } from "./firstInfo.vue?vue&type=template&id=64fd25a1"
import script from "./firstInfo.vue?vue&type=script&lang=js"
export * from "./firstInfo.vue?vue&type=script&lang=js"
import style0 from "./firstInfo.vue?vue&type=style&index=0&id=64fd25a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports